"use strict";
exports.__esModule = true;
function inject(services, objects) {
    for (var i = 0, count = objects.length; i < count; i++) {
        for (var name_1 in services) {
            if (typeof objects[i][name_1] === "function" && !objects[i][name_1]()) {
                objects[i][name_1](services[name_1]);
            }
        }
    }
}
exports.inject = inject;
